var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M45,46H3c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h42c1.105,0,2,0.895,2,2v36C47,45.105,46.105,46,45,46z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    fill: "#FFFFFF",
    width: 42,
    height: 31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E86C60",
    cx: 4.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFD358",
    cx: 9.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#72C472",
    cx: 14.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67C52",
    d: "M38.172,2.828c-1.105-1.105-2.895-1.105-4,0L21.536,15.464c0.988,0.181,1.899,0.65,2.625,1.376 c0.726,0.726,1.194,1.636,1.375,2.624L38.172,6.828C39.276,5.724,39.276,3.933,38.172,2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M21.536,15.464L16,21l4,4l5.536-5.536c-0.181-0.988-0.65-1.899-1.375-2.624 C23.435,16.115,22.524,15.646,21.536,15.464z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E86C60",
    d: "M41,41H7c-0.552,0-1-0.448-1-1v-7c0-0.552,0.448-1,1-1h34c0.552,0,1,0.448,1,1v7C42,40.552,41.552,41,41,41z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M20.863,27.192c0.89-0.934,1.387-2.146,1.387-3.441c0-1.336-0.52-2.591-1.464-3.535s-2.2-1.465-3.536-1.465 c-1.336,0-2.591,0.521-3.536,1.465c-1.056,1.056-1.467,3.263-1.623,5.089c1.596,0.415,2.689,0.727,3.846,1.04 C17.368,26.73,18.844,27.132,20.863,27.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E86C60",
    d: "M12.008,28.02l0.025,0.948l0.947,0.025C13.109,28.996,13.304,29,13.552,29c1.667,0,5.687-0.168,7.233-1.715 c0.029-0.029,0.049-0.064,0.077-0.094c-3.56-0.974-5.061-2.161-8.771-1.888C11.985,26.549,11.997,27.618,12.008,28.02z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/frontend.5bbf841f9cf3954d382dcdeb29333feb.svg";
export { ForwardRef as ReactComponent };